"use strict";
const modeNames = [
  "add",
  "adding",
  "selectOrMove",
  "selectOrMoveMouseDown",
  "moving"
];
export default _.object(modeNames, modeNames);
